import * as React from 'react';
import styled from 'styled-components';
import { useRecoilValue } from 'recoil';//取得のみ
import { nftJsonState } from "../states/nftJsonState";
import {
    Text,
} from '@chakra-ui/react';

type Props = {

}

export const NFTInfoName: React.FC<Props> = (props) => {
  const nftInfo = useRecoilValue(nftJsonState);

  return (
      <>
        <Text
            fontWeight={900}
            fontSize={'24px'}
            fontFamily={'sans-serif'}
            mb={'20px'}
        >
            {nftInfo.name}
        </Text>
      </>
  );
};